import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { getDataAPI } from '../../../utils/fetchData';

const Container = styled.div`
  height: 100%;
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
  height: 100%;
`;

const LeftCol = styled.div`
  display: flex;
  flex-direction: column;
  gap: 56px;
  padding-top: 8px;
`;

const RightCol = styled.div`
  display: flex;
  flex-direction: column;
  gap: 56px;
  padding-top: 8px;
  align-items: flex-end;
  text-align: right;
`;

const Label = styled.div`
  font-size: 12px;
  color: rgba(255, 255, 255, 0.55);
`;

const SubLabel = styled.div`
  font-size: 11px;
  color: rgba(255, 255, 255, 0.45);
`;

export default function ShowsModule() {
  const [stats, setStats] = useState({
    past: 0,
    upcoming: 0,
    finalTickets: 0,
    currentTickets: 0,
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchShowStats();
  }, []);

  const fetchShowStats = async () => {
    try {
      const token = localStorage.getItem('dizeeToken');
      if (!token) {
        setLoading(false);
        return;
      }

      // Try to fetch from bookings or tour manager
      const response = await getDataAPI('user/tm/shows', JSON.parse(token));
      
      if (response?.data?.data) {
        const shows = response.data.data;
        const now = new Date();
        
        const past = shows.filter(s => new Date(s.date) < now).length;
        const upcoming = shows.filter(s => new Date(s.date) >= now).length;
        
        setStats({
          past,
          upcoming,
          finalTickets: 0,
          currentTickets: 0,
        });
      }
    } catch (error) {
      console.log('Could not fetch show stats:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container>
      <Grid>
        <LeftCol>
          <div>
            <Label>Past</Label>
            {/* Keep counts available for future, but do not display in the mock layout */}
          </div>
          <div>
            <Label>Upcoming</Label>
          </div>
        </LeftCol>
        <RightCol>
          <div>
            <Label>Final ticket count</Label>
            <SubLabel>(finals)</SubLabel>
          </div>
          <div>
            <Label>Current ticket count</Label>
          </div>
        </RightCol>
      </Grid>
    </Container>
  );
}

